import { useSystemHealth } from "@/hooks/useSystemHealth";

/**
 * 데모 저장소 휘발 고지 (2026-07-16 전수조사 시정).
 *
 * SQLite 배포(Cloud Run 인스턴스-로컬)는 scale-to-zero/재배포 시 임무·리플레이·
 * 2FA·추가 계정이 통째로 초기화되는데 UI 어디에도 고지가 없어 '저장된다'는
 * 기대를 배신했다. storage.ephemeral=true 일 때만 표시 — 로컬 PostgreSQL
 * 구동에는 나타나지 않는다 (오탐 없음).
 */
export default function EphemeralStorageBanner() {
  const health = useSystemHealth();
  if (!health.data?.storage?.ephemeral) return null;
  return (
    <div
      data-testid="ephemeral-storage-banner"
      role="note"
      className="bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-900 text-amber-800 dark:text-amber-300 text-xs text-center px-3 py-1"
    >
      데모 인스턴스 — 서버 재시작 시 임무·리플레이·계정 등 모든 데이터가
      초기화됩니다
    </div>
  );
}
